import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid } from "../../../components";
import { formatPrice, responseErros } from "../../../utils";
import { history, notification, ServicoService } from "../../../services";
import { FormFiltroAvancado } from "./components";
import { PermisoesHelper } from "../../../helpers";

const ListServicos = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("servicos-visualizar");
  const [loading, setLoading] = useState(false);
  const [servicos, setServicos] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  
  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 500,
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 750,
    },
    {
      field: "precoServico",
      headerName: "Preço do Serviço",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
  ];
  const servicoService = new ServicoService();

  useEffect(() => {
    buscarServicos();
  }, []);

  const buscarServicos = async function (filter) {
    setLoading(true);
    const result = await servicoService.getAll(filter);
    if (!result.isAxiosError) {
      setServicos(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarServico = function () {
    history.push("/estoque/servicos/create");
  };

  const onClickEditServico = function (id) {
    history.push(`/estoque/servicos/${id}`);
  };

  const onClickDeleteServico = async function (id) {
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir esse serviço?`,
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await servicoService.deletar(id);
      if (!result.isAxiosError) {
        buscarServicos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const handlePesquisaAvancada = async (filter) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = { ...filter };

    if (
      filtrosAvancadosTemp.precoVendaStart &&
      filtrosAvancadosTemp.precoVendaEnd
    ) {
      porIntervalo.push({
        coluna: "precoVenda",
        de: filtrosAvancadosTemp.precoVendaStart,
        ate: filtrosAvancadosTemp.precoVendaEnd,
      });
    }

    if (
      (filtrosAvancadosTemp.precoVendaStart &&
        !filtrosAvancadosTemp.precoVendaEnd) ||
      (!filtrosAvancadosTemp.precoVendaStart &&
        filtrosAvancadosTemp.precoVendaEnd)
    ) {
      return notification.erroValidacao(
        "Preencher preço de venda inicial e final",
      );
    }

    delete filtrosAvancadosTemp.precoVendaStart;
    delete filtrosAvancadosTemp.precoVendaEnd;
    const result = await servicoService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });

    if (!result.isAxiosError) {
      setServicos(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarServicos(props.filtros);
    } else {
      handlePesquisaAvancada(props.filtros);
    }
  };

  return (
    <ListLayout
      title="Serviços"
      loading={loading}
      onClickCadastrar={onClickCadastrarServico}
            permissaoButton={permissoesHelper.temPermisao("servicos-cadastrar")}
    >
      <DataGrid
        rows={servicos}
        rowCount={rowCount}
        columns={colunas}
        onClickEdit={onClickEditServico}
        onClickDelete={onClickDeleteServico}
        visualizarShow={permissoesHelper.temPermisao("servicos-visualizar")}
        editShow={permissoesHelper.temPermisao("servicos-editar")}
        deleteShow={permissoesHelper.temPermisao("servicos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
      />
    </ListLayout>
  );
};

export default ListServicos;
